export default function Key_config() {
    return {
        "search_score": "@search.score",
        "item_row_number": "ItemRowNumber",
        "AssetURL": "AssetURL",
        "ObsoleteFlag": "ObsoleteFlag",
        "EndOfLifeOFlag": "EndOfLifeOFlag",
        "EndofLifeFlag": "EndofLifeFlag",
        "item_number": "ItemNumber",
        "type": "Type",
        "published": "Published",
        "delete_flag": "DeleteFlag",
        "sboat": "Sboat",
        "division_code_name": "DivisionCodeName",
        "w_c_s_part_number": "WCSPartNumber",
        "e_r_p_part_number": "ERPPartNumber",
        "qty_min": "QtyMin",
        "qty_mult": "QtyMult",
        "e_r_p_manufacturer_name": "ERPManufacturerName",
        "e_r_p_manufacturer_code": "ERPManufacturerCode",
        "vendor_part_number": "VendorPartNumber",
        "e_r_p_supplier_code": "ERPSupplierCode",
        "e_r_p_m_f_r_part_number": "ERPMFRPartNumber",
        "m_d_m_material_id": "MDMMaterialID",
        "manufacturer_part_number": "ManufacturerPartNumber",
        "variant_m_f_r_name": "VariantMFRName",
        "variant_m_f_r_code": "VariantMFRCode",
        "e_c_c_n_code": "ECCNCode",
        "h_t_s_code": "HTSCode",
        "schedule_b_code": "ScheduleBCode",
        "r_o_h_s_compliant_code": "ROHSCompliantCode",
        "life_cycle_risk": "LifeCycleRisk",
        "e_r_p_categorization1": "ERPCategorization1",
        "e_r_p_categorization2": "ERPCategorization2",
        "e_r_p_categorization3": "ERPCategorization3",
        "e_r_p_categorization4": "ERPCategorization4",
        "s_a_p_matgroup": "SAPMatgroup",
        "package_size_mandatory_flag": "PackageSizeMandatoryFlag",
        "allocation_flag": "AllocationFlag",
        "factory_lead_time": "FactoryLeadTime",
        "top_seller_flag": "TopSellerFlag",
        "n_c_n_r_flag": "NCNRFlag",
        "software_download_flag": "SoftwareDownloadFlag",
        "software_flag": "SoftwareFlag",
        "web_only_flag": "WebOnlyFlag",
        "schedulable_flag": "SchedulableFlag",
        "packaging_type_code": "PackagingTypeCode",
        "obsolete_date": "ObsoleteDate",
        "endof_life_date": "EndofLifeDate",
        "active_date": "ActiveDate",
        "design_win_flag": "DesignWinFlag",
        "DesignIds": "DesignIds",
        "IsDesignsAvailable": "IsDesignsAvailable",
        "web_code": "WebCode",
        "military_product_flag": "MilitaryProductFlag",
        "hazardous_flag": "HazardousFlag",
        "i_t_a_r_flag": "ITARFlag",
        "s_a_p_material_pricing_group_code": "SAPMaterialPricingGroupCode",
        "excess_inventory_flag": "ExcessInventoryFlag",
        "lead_free_flag": "LeadFreeFlag",
        "green_compliant_flag": "GreenCompliantFlag",
        "sales_org": "SalesOrg",
        "p_i_m_block": "PIMBlock",
        "e_r_p_system_name": "ERPSystemName",
        "a_b_c_code1": "ABCCode1",
        "a_b_c_code2": "ABCCode2",
        "a_b_c_code3": "ABCCode3",
        "programmable_flag": "ProgrammableFlag",
        "e_r_p_product_status": "ERPProductStatus",
        "d_w_effective_date": "DWEffectiveDate",
        "d_w_end_date": "DWEndDate",
        "e_r_p_part_create_date": "ERPPartCreateDate",
        "first_time_buy_date": "FirstTimeBuyDate",
        "franchise_flag": "FranchiseFlag",
        "last_time_buy_date": "LastTimeBuyDate",
        "last_time_return_date": "LastTimeReturnDate",
        "last_time_ship_date": "LastTimeShipDate",
        "value_added_flag": "ValueAddedFlag",
        "w_s_t_s_code": "WSTSCode",
        "e_r_p_purchase_status": "ERPPurchaseStatus",
        "business_block": "BusinessBlock",
        "sys_delete_fl": "sys_delete_fl",
        "sys_create_dt": "sys_create_dt",
        "sys_delete_dt": "sys_delete_dt",
        "sys_delta_dt": "sys_delta_dt",
        "sys_update_dt": "sys_update_dt",
        "variant_number": "VariantNumber",
        "manufacturer_code": "ManufacturerCode",
        "manufacturer_name": "ManufacturerName",
        "ManufacturerLogo": "ManufacturerLogo",
        "alias_part_number_secondary_supplier": "AliasPartNumberSecondarySupplier",
        "alias_part_number_military": "AliasPartNumberMilitary",
        "manufacturer_datasheet_url": "ManufacturerDatasheetURL",
        "i_h_s_manufacturer_datasheet_url": "IHSManufacturerDatasheetURL",
        "family_name": "FamilyName",
        "enrichment_level": "EnrichmentLevel",
        "part_enrichment_accounting": "PartEnrichmentAccounting",
        "r_o_h_s_version_code": "ROHSVersionCode",
        "r_o_h_s_exemptions": "ROHSExemptions",
        "r_o_h_s_update_date": "ROHSUpdateDate",
        "reach_compliant_flag": "ReachCompliantFlag",
        "china_r_o_h_s_compliant_code": "ChinaROHSCompliantCode",
        "prop65_flag": "Prop65Flag",
        "supply_chain_risk": "SupplyChainRisk",
        "environmental_risk": "EnvironmentalRisk",
        "d_r_c_status": "DRCStatus",
        "prop65_c_a_s": "Prop65CAS",
        "n_p_i_date": "NPIDate",
        "n_p_i_flag": "NPIFlag",
        "active_variant_flag": "ActiveVariantFlag",
        "structuregroupidentifier": "Structuregroupidentifier",
        "long_description": "LongDescription",
        "product_features": "ProductFeatures",
        "structure_name": "StructureName",
        "level_1_id": "Level_1_ID",
        "level_1_name": "Level_1_Name",
        "level_1_url": "Level_1_URL",
        "level_2_id": "Level_2_ID",
        "level_2_name": "Level_2_Name",
        "level_2_url": "Level_2_URL",
        "level_3_id": "Level_3_ID",
        "level_3_name": "Level_3_Name",
        "level_3_url": "Level_3_URL",
        "level_4_id": "Level_4_ID",
        "level_4_name": "Level_4_Name",
        "level_4_url": "Level_4_URL",
        "structure_hierarchy": "StructureHierarchy",
        "attributes": "Attributes",
        "attribute_identifier": "AttributeIdentifier",
        "attr_name": "ATTRNAME",
        "att_combo": "ATTCOMBO",
        "attr_val": "ATTRVAL",
        "max_val": "MAXVAL",
        "min_val": "MINVAL",
        "nrm_val": "NRMVAL",
        "customer_part_numbers": "CustomerPartNumbers",
        "short_description": "ShortDescription",
        "imagePath": "ImagePath",
        "thumbnailPath": "ThumbnailPath",
        "vendorCode": "VendorCode",
        "stock": "Stock",
        "farnellInventorySharing": "FarnellInventorySharing",
        "TopProducts": "TopProducts",
        "sap_originating_countryoforigin": "sap_originating_countryoforigin"
    };
}